export enum PaymentTokenType {
  STT = 'stt',
  OTT = 'ott'
}

export enum PaymentTransactionType {
  PAYMENT = 'payment',
  AUTHORISATION = 'authorisation',
  REFUND = 'refund'
}

export enum PaymentType {
  CUSTOM_CHECKOUT = 'customcheckout',
  SAVED_CARD = 'savedcard',
  SAVED_DIRECT_DEBIT = 'saveddirectdebit'
}

export enum PaymentSource {
  IVR = 'ivr',
  MY_ACCOUNT = 'my_account',
  WEBSITE = 'website'
}

export enum WebsitePaymentType {
  CARD = 'card',
  PAYPAL = 'paypal'
}
